import type { ReactNode } from 'react';
import { HorizontalStack } from '../../alignment/horizontal-stack';
import { VerticalStack } from '../../alignment/vertical-stack';
import { Typography } from '../../typography';
import styles from './info-list.module.scss';

export interface InfoListItem {
  id: string;
  icon: ReactNode;
  title: string;
  description: string;
}

export interface InfoListProps {
  items: InfoListItem[];
}

export function InfoList({ items }: InfoListProps) {
  return (
    <VerticalStack as="ul" className={styles.infoList} gap={4}>
      {items.map((item) => (
        <VerticalStack as="li" gap={2} key={item.id}>
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <div className={styles.iconContainer}>{item.icon}</div>

            <Typography lineHeight="1.5rem" size="1rem">
              {item.title}
            </Typography>
          </HorizontalStack>

          <Typography lineHeight="1.125rem" size="0.875rem">
            {item.description}
          </Typography>
        </VerticalStack>
      ))}
    </VerticalStack>
  );
}
